module.exports = __webpack_public_path__ + "img/star_opaque.70e7709e.svg";